import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const AdminHeader = ({setToggled, toggled}) => {
  const handleToggle = () => {
    setToggled(! toggled)
  }

  return (
    <div className="admin__top-nav">
      <button
        type="button"
        style={{border:0, background: 'none', color: '#fcfcfc'}}
        onClick={handleToggle}
        className="ml-2 d-xs-block d-md-none d-lg-none"
      >
        <FontAwesomeIcon icon={['fas', 'bars']} />
      </button>
    </div>
  )
}

export default AdminHeader